import {Fragment} from 'react';
import uniqueId from 'lodash/uniqueId';
import type {PartValueRenderer} from 'schema/types';
import type {CodeList} from 'services/codelists/types';
import type {Dewey as DeweyType} from 'services/metadata/types';
import {useCodelist} from 'services/codelists/hooks';
import {Builder, isDeweyValue} from 'services/utils';
import {CopyToClipboard} from 'components';
import {useTextValue} from 'schema/preview/hooks';

const formatDewey = (dewey: DeweyType, deweySource: CodeList) => {
  return new Builder(dewey.value).add(
    ', ',
    dewey.source
      ? deweySource.codes.find(c => c.code === dewey.source)?.value
      : null,
  ).value;
};

export const Dewey: PartValueRenderer = ({value}) => {
  const deweySource = useCodelist('DEWEY_SOURCE');
  const TextValue = useTextValue();

  const values = Array.isArray(value) && value.length > 0 ? value : undefined;
  const deweyValues = values?.filter(isDeweyValue);

  return !deweyValues ? null : (
    <TextValue>
      {deweyValues.map(v => (
        <Fragment key={v.value ?? uniqueId('dewey-')}>
          {formatDewey(v, deweySource)}
          <CopyToClipboard text={v.value ?? ''} size={'small'} />
        </Fragment>
      ))}
    </TextValue>
  );
};
